import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { ThreeImageCardContainer } from 'containers/common/components/three-image-block/three-image-card-container';

import { CtaBox, CtaBoxHeader } from 'components/cta-box';
import PageSection from 'components/page/page-section';
import { BulletPoints } from 'components/three-image-block/bullet-points';

export const SuperswipeBlockThreeContainer: FunctionComponent = () => {
    const content = [
        `${features.superswipe.lxSuperswipeThreeBlockPointOne}`,
        `${features.superswipe.lxSuperswipeThreeBlockPointTwo}`,
        `${features.superswipe.lxSuperswipeThreeBlockPointThree}`,
    ];

    const images = [
        {
            imageId: 1,
            src: `${CdnImagePath}/landing/assets/photos/features/superswipe/superswipe-block-3-image-1.jpg`,
        },
        {
            imageId: 2,
            src: `${CdnImagePath}/landing/assets/photos/features/superswipe/superswipe-block-3-image-2.jpg`,
        },
        {
            imageId: 3,
            src: `${CdnImagePath}/landing/assets/photos/features/superswipe/superswipe-block-3-image-3.jpg`,
        },
    ];
    return (
        <PageSection color="orange" padding="block" inner={true}>
            <CtaBox align="center">
                <CtaBoxHeader tag="h1">
                    {features.superswipe.lxSuperswipeThreeBlockTitle}
                </CtaBoxHeader>

                <BulletPoints content={content} />
                <ThreeImageCardContainer images={images} />
            </CtaBox>
        </PageSection>
    );
};
